/**
 * @file getKeys Get all enumerable keys of the source object with corresponding tuple type.
 * @author Yu Zong(liuxuanzy@qq.com)
 */

/**
 * Get all enumerable keys of the source object with corresponding tuple type.
 *
 * @param obj The source object.
 * @return All enumerable keys of the source object with corresponding tuple type.
 */
export function getKeys(obj) {
  return Object.keys(obj);
}